import React, { FunctionComponent } from "react";
import { useTranslation } from "react-i18next";

import { useCmsLink } from "../Header/useCmsLink";

export const CmsLink: FunctionComponent = () => {
  const { t } = useTranslation();
  const link = useCmsLink();
  return (
    // eslint-disable-next-line react/jsx-no-target-blank
    <a
      className="text-sm underline mb-4 md:mb-6 inline-block"
      href={link}
      target="_blank"
    >
      {t("pricingAnalysis.openCMS")}
    </a>
  );
};
